import { CustomConverter, JsonObject, JsonProperty, Optional } from 'json-ts-mapper';
import { DateTimeConverter } from './converters/datesConverters';
import { DomiciliationBancaire } from './domiciliations-bancaires';

@JsonObject
export class ModeReglement {
  constructor (
    codeReglement?: string,
    dateDebut?: Date,
    dateFin?: Date,
    libelle?: string,
    tauxEscompte?: number,
    codeFiliere?: string,
    multiEcheance?: boolean,
    nbEcheances?: number,
    saisieDb?: string,
    codeReglementCompta?: string,
    typeEcheance?: string,
    dateEcheance?: Date,
    dateEcheanceModifiable?: boolean,
    tauxEscompteModifiable?: boolean,
    domiciliationsBancaires?: DomiciliationBancaire[]

  ) {
    this.codeReglement = codeReglement as any;
    this.dateDebut = dateDebut as any;
    this.dateFin = dateFin as any;
    this.libelle = libelle as any;
    this.tauxEscompte = tauxEscompte as any;
    this.codeFiliere = codeFiliere as any;
    this.multiEcheance = multiEcheance as any;
    this.nbEcheances = nbEcheances as any;
    this.saisieDb = saisieDb as any;
    this.codeReglementCompta = codeReglementCompta as any;
    this.typeEcheance = typeEcheance as any;
    this.dateEcheance = dateEcheance as any;
    this.dateEcheanceModifiable = dateEcheanceModifiable as any;
    this.tauxEscompteModifiable = tauxEscompteModifiable as any;
    this.domiciliationsBancaires = domiciliationsBancaires as any;
  }

  @JsonProperty(String)
  codeReglement: string;

  @JsonProperty(String)
  libelle: string;

  @JsonProperty(String)
  @Optional
  @CustomConverter(DateTimeConverter)
  dateDebut: Date;

  @JsonProperty(String)
  @Optional
  @CustomConverter(DateTimeConverter)
  dateFin: Date;

  @JsonProperty(Number)
  @Optional
  tauxEscompte: number;

  @JsonProperty(String)
  @Optional
  codeFiliere: string;

  @JsonProperty(Boolean)
  @Optional
  multiEcheance: boolean;

  @JsonProperty(Number)
  @Optional
  nbEcheances: number;

  @JsonProperty(String)
  @Optional
  saisieDb: string;

  @JsonProperty(String)
  @Optional
  codeReglementCompta: string;

  @JsonProperty(String)
  typeEcheance: string;

  @JsonProperty(String)
  @Optional
  @CustomConverter(DateTimeConverter)
  dateEcheance: Date;

  @JsonProperty(Boolean)
  @Optional
  dateEcheanceModifiable: boolean;

  @JsonProperty(Boolean)
  @Optional
  tauxEscompteModifiable: boolean;

  @JsonProperty([DomiciliationBancaire])
  @Optional
  domiciliationsBancaires: DomiciliationBancaire[]
}
